// extracted by mini-css-extract-plugin
export default {"stores-links":"foqSU","icon-wrap":"Cu2Ia"};